import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from "@angular/forms";
import { FormService } from "../../services/form.service";

@Component( {
	selector: 'app-property-type-to',
	templateUrl: './property-type-to.component.html',
	styleUrls: ['./property-type-to.component.scss']
} )
export class PropertyTypeToComponent implements OnInit {

	propertyTypeTo !: UntypedFormGroup;
	formGroupName: string = 'propertyTypeTo';

	constructor( public formService: FormService ) {
	}

	ngOnInit(): void {

		this.propertyTypeTo = this.formService.mainForm.get( this.formGroupName ) as UntypedFormGroup;
	}

	onSubmit() {

		this.formService.submitFormGroup( (<UntypedFormGroup>this.propertyTypeTo) );
	}

	onRadioChange( $event: any ) {

		// Small timeout for user experience
		setTimeout( () => {

			this.onSubmit();
		}, 200 );
	}
}
